module.exports = __webpack_public_path__ + "static/media/smk-logo.175cab63.png";